import { TorchesDataEntryPage } from "./DataEntryPage";
import {
  TorchesDataEntryProvider,
  useDataEntryContext,
} from "./context/reducer.provider";
import { TimerProvider } from "./context/timer.provider";

import { themeMESF } from "@dexteel/mesf-core";
import { ThemeProvider } from "@mui/material/styles";

type Props = {};
const TorchesDataEntry = (props: Props) => {
  return (
    <TorchesDataEntryProvider>
      <TimerProviderWrapper />
    </TorchesDataEntryProvider>
  );
};

const TimerProviderWrapper = () => {
  const { state } = useDataEntryContext();
  return (
    <TimerProvider
      isOldProcess={!!state.deProcess?.process.IsOldProcessTorches}
    >
      <div id={"dummy"} style={{ height: "0", width: "0" }}></div>
      <ThemeProvider theme={themeMESF}>
        <TorchesDataEntryPage />
      </ThemeProvider>
    </TimerProvider>
  );
};
export default TorchesDataEntry;
